<template>
  <ul class="breadcrumb">
    <li v-for="item in list" :key="item.id"><strong>{{ item }}</strong></li>
  </ul>
</template>

<script>
export default {
  props: ['list']
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue